module.exports = __webpack_public_path__ + "static/media/app-bar-logo.1cfe064a.svg";